import { render, staticRenderFns } from "./ScrollablePane.vue?vue&type=template&id=0c1d7ca2&scoped=true&"
import script from "./ScrollablePane.vue?vue&type=script&lang=ts&"
export * from "./ScrollablePane.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollablePane.vue?vue&type=style&index=0&id=0c1d7ca2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1d7ca2",
  null
  
)

export default component.exports